exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table>tr>td[data-v-017149db]{width:30%;height:45px}.b2c_display_pic[data-v-017149db]{width:100px}", ""]);

// exports
